// extracted by mini-css-extract-plugin
export default {"table":"CabinPickerTable_table__Wwh+X","table-body-row":"CabinPickerTable_table-body-row__mLSMy","selected":"CabinPickerTable_selected__7DayB"};